import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseEntityComponent, BaseEntityConfig, BnLoadingService } from '@bndes/bndes-ux4/bndes-angular-utils';
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ModalidadeService } from '../../../shared/services/modalidade.service';
import { DetalheLeilao } from 'src/app/model/leilao.model';
import { DetalheLeilaoService } from '../detalhe-leilao.service';


@Component({
  selector: 'app-detalhe-leilao',
  templateUrl: './detalhe-leilao.component.html',
  styleUrls: ['./detalhe-leilao.component.scss'],
  standalone: false
})
export class DetalheLeilaoComponent extends BaseEntityComponent<DetalheLeilao> implements OnInit {

    private agentesFinanceiros: AgenteFinanceiro[] = [];
    private idLeilao: number;
    public detalheLeilao: DetalheLeilao[];
    public detalheLeilaoFiltrado: DetalheLeilao;
    public permissaoLinkN03: false;
    public nomeModalidade: string;
    public activeTabId: string = 'detalhes';

    constructor(
      protected injector: Injector,
      protected service: DetalheLeilaoService,
      private permissaoService: PermissaoService,
      private modalService: BnModalMessageService,
      private loadingService: BnLoadingService,
      private activatedRoute: ActivatedRoute,
      private modalidadeService: ModalidadeService
    ) {
      super(service, new BaseEntityConfig('/leilao'));
      this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
      this.config.rotaLista = '/leilao';
    }

    ngOnInit() {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.permissaoLinkN03 = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);
        });
        this.route.params.subscribe(params => {
            this.idLeilao = params['id'];
            this.atualizarDetalheLeilao();
        });
        this.modalidadeService.modalidade$.subscribe((mod) => {
            for (let modalidade of this.modalidadeService.getModalidades()) {
                if (modalidade.sigla == mod) {
                  this.nomeModalidade = modalidade.nome;
                }
              }
        });
    }

    atualizarDetalheLeilao() {
      this.loadingService.bloqueiaTela();
      this.service.getDetalheLeilao(this.idLeilao).subscribe(resp => {
        this.detalheLeilao = resp;
        this.detalheLeilaoFiltrado = this.detalheLeilao[0];
        if (this.detalheLeilao?.length) {
          this.detalheLeilaoFiltrado.dataRecebimentoValorArrematado = this.ajustaCampoDate(this.detalheLeilaoFiltrado.dataRecebimentoValorArrematado);
        }
      }, err => {
        this.loadingService.liberaTela();
      });

      this.loadingService.liberaTela();
    }

    cancelaReprovacao() {
        this.modalService.dismiss('abortou reprovação');
    }

    private nomeAgente(cnpj: string) {
        return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
    }

    private mesAno(valor?: string): string {
        return Utils.mesAno(valor);
    }

    ajustaCampoDate(data:any) {
        if (typeof data === 'string') {
          if (data.length == 10) {
            data += ' 00:00:00';
          }
          return new Date(data);
        }

        return data;
    }

  onTabChange(event: any): void {
    this.activeTabId = event.nextId;
  }

  compareExiste(item: DetalheLeilao){
      if(item.contratoRepasse == undefined && item.sistemaRepasse == undefined){
          return "";
      } else if(item.contratoRepasse != undefined && item.sistemaRepasse == undefined ){
          return item.contratoRepasse;
      } else if(item.contratoRepasse == undefined && item.sistemaRepasse != undefined ){
          return item.sistemaRepasse;
      } else if(item.contratoRepasse != undefined && item.sistemaRepasse != undefined ) {
        return item.sistemaRepasse + '/' + item.contratoRepasse;
      }
  }

}
